import { faDisplay } from "@fortawesome/pro-light-svg-icons"
import { faChartSimple, faLocationDot } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { IFormInventory, INVENTORY_MAP_VIEW_TYPES } from "form/inventory/model"
import { getInventory } from "form/inventory/tools/common"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { InventoryMapButton } from "./InventoryMapButton"

interface IInventoryMapButtonsProps {
  inventory: IFormInventory
}

const InventoryMapButtonsFn = React.memo(
  ({
    inventory: { mapViewType, totalGeoTargets, totalScreens, totalImpressions, isRefreshing }
  }: IInventoryMapButtonsProps) => (
    <FlexBox
      jc="end"
      sx={{
        width: "100%",
        position: "relative",
        flexWrap: "wrap",
        mt: "-.3rem",
        pr: ".5rem",
        pl: ".5rem",
        backgroundColor: theme => theme.palette.background.paper
      }}>
      {totalGeoTargets > 0 && (
        <InventoryMapButton
          viewType={INVENTORY_MAP_VIEW_TYPES.GEO_TARGETS}
          count={totalGeoTargets}
          label={translate("label.geo-targets")}
          icon={faLocationDot}
          isActive={mapViewType === INVENTORY_MAP_VIEW_TYPES.GEO_TARGETS}
          isRefreshing={false}
        />
      )}
      <InventoryMapButton
        viewType={INVENTORY_MAP_VIEW_TYPES.SCREENS}
        count={totalScreens}
        label={translate("label.screens")}
        icon={faDisplay}
        isActive={mapViewType === INVENTORY_MAP_VIEW_TYPES.SCREENS}
        isRefreshing={isRefreshing}
      />
      <InventoryMapButton
        viewType={INVENTORY_MAP_VIEW_TYPES.IMPRESSIONS}
        count={totalImpressions}
        label={translate("label.impressions")}
        icon={faChartSimple}
        isActive={mapViewType === INVENTORY_MAP_VIEW_TYPES.IMPRESSIONS}
        isRefreshing={isRefreshing}
      />
    </FlexBox>
  )
)

export const InventoryMapButtons = connect(
  (state: IRootState): IInventoryMapButtonsProps => ({
    inventory: getInventory(state)
  })
)(InventoryMapButtonsFn)
